module.exports = __webpack_public_path__ + "double-good.png?c5a4287742c5545b1ef97061f3052103";